export default __webpack_public_path__ + "static/media/peopleSummary.8cf0798a.png";